<div id=fullPage>
  <div class="col-lg-4 col-md-6  col-sm-12 col-xs-12 nopadding">
    <app-cat-report></app-cat-report>
  </div>
  <div class=" col-lg-4  col-md-6 col-sm-12 col-xs-12 nopadding">
    <app-cat-pre-submission-details></app-cat-pre-submission-details>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nopadding">
    <app-cat-finra-submission-feedback></app-cat-finra-submission-feedback>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nopadding">
    <!-- <app-cat-transaction-catroe-graph></app-cat-transaction-catroe-graph> --> <!-- Keeping it commented for Future Reference -->
    <app-firm-wide-cat-summary></app-firm-wide-cat-summary>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nopadding">
    <app-cat-transaction-error-graph></app-cat-transaction-error-graph>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nopadding">
    <app-cat-finra-rejects-graph></app-cat-finra-rejects-graph>
  </div>
</div>